import { ReviewRecord } from "@graphql/types/graphql";
import { IconType } from "@types";
import { Icon } from "components/atoms/Icon/Icon";
import { FC } from "react";
import { Image } from "react-datocms";
import "swiper/css";
import "swiper/css/pagination";
import s from "./Review.module.scss";

interface Props {
    data: ReviewRecord;
}
export const Review: FC<Props> = ({
    data,
}) => {
    const maxRating = 5;

    const reviewStructuredData = {
        "@context": "https://schema.org",
        "@type": "Review",
        reviewBody: data.quote,
        itemReviewed: {
            "@type": "Organization",
            name: "PIA Group",
        },
        reviewRating: {
            "@type": "Rating",
            ratingValue: data.rating,
            bestRating: maxRating,
            worstRating: 1,
        },
        author: {
            "@type": "Person",
            name: data.name,
            ...(data.jobTitle && { jobTitle: data.jobTitle }),
        },
    };

    return (
        <>
            <div className={s.Review}>
                <div className={s.Content}>
                    <blockquote className={s.ReviewQuote}>
                        <p>{data.quote}</p>
                    </blockquote>
                    <div className={s.ReviewDetails}>
                        <div className={s.ReviewInfo}>
                            <p className={s.Name}>{data.name}</p>
                            {data.jobTitle && <p>{data.jobTitle}</p>}
                            <div className={s.Rating}>
                                {Array.from({ length: maxRating }, (_, i) => (
                                    <Icon name={IconType.Star} size="m" color={i < data.rating ? "blue" : "medium-grey"} />
                                ))}
                            </div>
                        </div>
                        {data.image && (
                            <div className={s.ReviewImage}>
                                <Image data={data.image.responsiveImage} />
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <script
                type="application/ld+json"
                dangerouslySetInnerHTML={{ __html: JSON.stringify(reviewStructuredData) }}
            />
        </>
    )
}